module.exports = require("node:module");